    <template >
  <div >

  <div>
  <div class="formPosition">
    <template>

      <!--  classes em aue se tem discplinas  -->
      <v-container
        class="grey lighten-5"
      >
        <v-row no-gutters>
          <v-col >
            <strong>Disciplinas</strong>
            <br />
            <div class="text-center">
            </div>
          </v-col>
        </v-row>
        <v-row>
<v-col class="d-flex" cols="12" >
            <v-progress-linear v-if="progresso"
            color="green"
            indeterminate
            rounded
            height="3"
          ></v-progress-linear>
        </v-col>
        </v-row>
      </v-container>
      <v-container>
        <v-row no-gutters>
          <v-col>
            <template
             >
              <v-container class="text-md-left">
                <v-row no-gutters>
                  <v-col>
                    <v-card class="d-flex flex-row mb-6" max-width="400" tile>
                      <v-list flat>
                        <v-subheader>você tem ({{disciplinas.length}}) disciplinas. clica em uma delas para prosseguir

                        </v-subheader>
                        <v-list-item-group color="primary">
                          <v-list-item
                          v-for="item in disciplinas"
                            :key="item.iddisciplina"
                          >
                            <v-list-item-icon>
                            </v-list-item-icon>

                            <v-list-item-content color="primary" dark >
                              <v-list-item-title v-text="item.disciplina" @click="aulasPubicadasDestaDisciplina(item)"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </template>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </template>
  </div>
  </div>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
export default {
  data: () => ({
    disciplinas: [],
    progresso: false
  }),
  created () {
    window.location.href = 'http://aulas.softlineangola.com'
  },

  methods: {
    aulasPubicadasDestaDisciplina (item) {
      this.$store.state.objDisciplina = item
      this.$router.push('aulas')
    },
    async initializeDisciplinas () {
      try {
        this.progresso = true
        this.disciplinas = await axios
          .get('/listarDisciplinasActuaisDoAluno/1')
          .then(res => res.data)
        this.progresso = false
      } catch (error) {
        this.progresso = false
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    }
  }
}
</script>
